export class UserUtils {
  private static getLangRegexp(): RegExp {
    return /^(?:en|de|es|fr|it|nl|pl)$/;
  }

  static resolveLangRegexp(): RegExp {
    return UserUtils.getLangRegexp();
  }
}
